import {makeAutoObservable} from "mobx";

export default class DirectChatStore {
    constructor() {
        this._sessions = [];
        this._currentChat = null;
        this._messages = [];
        this._isLoading = false;
        this._lastNotification = null;

        makeAutoObservable(this);
    }

    // -------- setters --------

    setSessions(sessions) {
        this._sessions = Array.isArray(sessions) ? sessions : [];
    }

    setCurrentChat(chat) {
        this._currentChat = chat || null;
    }

    setMessages(messages) {
        this._messages = Array.isArray(messages) ? messages : [];
    }

    setIsLoading(value) {
        this._isLoading = Boolean(value);
    }

    addMessage(message) {
        if (!message?.id) return;

        const exists = this._messages.some(
            item => String(item.id) === String(message.id)
        );

        if (exists) return;

        this._messages.push(message);
    }

    upsertSession(updatedChat) {
        if (!updatedChat?.id) return false;

        const filtered = this._sessions.filter(
            item => String(item.id) !== String(updatedChat.id)
        );

        this._sessions = [updatedChat, ...filtered];

        return true;
    }

    clearUnread(chatId) {
        const item = this._sessions.find(
            session => String(session.id) === String(chatId)
        );

        if (item) {
            item.unreadCount = 0;
        }

        if (
            this._currentChat &&
            String(this._currentChat.id) === String(chatId)
        ) {
            this._currentChat = {
                ...this._currentChat,
                unreadCount: 0
            };
        }
    }

    markOwnMessagesAsRead(currentUserId) {
        this._messages.forEach(message => {
            if (Number(message.senderUserId) === Number(currentUserId)) {
                message.isRead = true;
            }
        });
    }

    setLastNotification(chat) {
        this._lastNotification = {
            id: Date.now(),
            chat
        };
    }

    clearLastNotification() {
        this._lastNotification = null;
    }

    clearStore() {
        this._sessions = [];
        this._currentChat = null;
        this._messages = [];
        this._isLoading = false;
        this._lastNotification = null;
    }

    // -------- getters --------

    get sessions() {
        return this._sessions;
    }

    get currentChat() {
        return this._currentChat;
    }

    get messages() {
        return this._messages;
    }

    get isLoading() {
        return this._isLoading;
    }

    get totalUnreadCount() {
        return this._sessions.reduce((total, session) => {
            return total + Number(session.unreadCount || 0);
        }, 0);
    }

    get lastNotification() {
        return this._lastNotification;
    }
}